import type { ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './RowActionPill.module.css';

export type RowActionPillProps = {
  primary: ReactNode;
  menu?: ReactNode;
  disabled?: boolean;
  /** Narrow viewports: hide primary strip, menu chevron only. */
  responsive?: boolean;
  className?: string;
};

/** Shared pill shell for table row actions (primary button + optional ⋮ menu). */
export function RowActionPill({ primary, menu, disabled, responsive, className }: RowActionPillProps) {
  return (
    <span
      className={cx(styles.shell, disabled && styles.shellDisabled, responsive && styles.shellResponsive, className)}
      data-wp-row-action-pill
      data-wp-row-action-pill-responsive={responsive || undefined}
    >
      <span className={styles.primarySlot}>{primary}</span>
      {menu ? (
        <>
          <span className={styles.separator} aria-hidden />
          <span className={styles.menuSlot}>{menu}</span>
        </>
      ) : null}
    </span>
  );
}
